import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {AutoplayHandlerEvents} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {InfoPopupEvents} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupEvents';
import {InfoPopupTypes} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupTypes';
import {InfoPopupView} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupView';

/**
 * information popups module
 */
export class InfoPopupModule extends Module<InfoPopupView> {
	protected _currentMessageType: InfoPopupTypes;

	public restore(): void {
		super.restore();

		if (this.logic.isFreeSpinsStarted && this.logic.freeSpinsPlayed === 0) {
			// Don't show the popup when restoring to FS screen.
			return;
		}

		this._currentMessageType = InfoPopupTypes.RESTORE;
		const restoreText: string =
			this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplay_replayingInterruptedGame') || 'Replaying interrupted game';
		this.view.showOKMessage(restoreText);
		this.eventManager.emit(InfoPopupEvents.RESTORE_POPUP_OPENED);
	}

	protected enterFirstState(): void {}

	protected setupStates(): void {}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.INFO_POPUP_VIEW_MOBILE);
		} else {
			this.setView(Views.INFO_POPUP_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onView(InfoPopupView.OK_CLICKED, this.onOkClicked);
		this.onView(InfoPopupView.HOME_CLICKED, this.onHomeClicked);

		this.on(SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onNotEnoughMoneyToSpin);
		this.on(AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT, this.onWinLimitReached);
		this.on(AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_WIN_LIMIT, this.onWinLimitReached);
		this.on(AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_LOSE_LIMIT, this.onLossLimitReached);

		if (!__PRODUCTION__) {
			document.addEventListener('keydown', this.onKeyInput.bind(this));
		}
	}

	protected onKeyInput(event: KeyboardEvent): void {
		if (event.code === 'KeyM') {
			this.view.showSimpleMessage('some some text');
		}

		if (event.code === 'KeyN') {
			this.view.showErrorMessage('some some text');
		}

		if (event.code === 'KeyR') {
			this.view.showRealityCheckWithExitOptionMessage('some some text\nsome some text\nsome some text\nsome some text\nsome some text\nsome some text\nsome some text\n');
		}
	}

	protected onNotEnoughMoneyToSpin(): void {
		this._currentMessageType = InfoPopupTypes.NO_MONEY;
		const notEnoughText: string = this.view.translator.getObject('BaseStrings', 'generic', 'g_noMoney') || 'Not enough money to spin';
		this.view.showOKMessage(notEnoughText);
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
	}

	protected onWinLimitReached(): void {
		this._currentMessageType = InfoPopupTypes.WIN_LIMIT;
		const autoplayStoppedText: string =
			this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplayStopped') || 'AutoPlay stopped';
		const winLimitReachedText: string =
			this.view.translator.getObject('BaseStrings', 'generic', 'g_WinLimitreached') || 'Win Limit reached';
		this.view.showOKMessage(`${autoplayStoppedText}. ${winLimitReachedText}`);
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
	}

	protected onLossLimitReached(): void {
		this._currentMessageType = InfoPopupTypes.LOSS_LIMIT;
		const autoplayStoppedText: string =
			this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplayStopped') || 'AutoPlay stopped';
		const lossLimitReachedText: string =
			this.view.translator.getObject('BaseStrings', 'generic', 'g_LossLimitReached') || 'Loss Limit reached';
		this.view.showOKMessage(`${autoplayStoppedText}. ${lossLimitReachedText}`);
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
	}

	protected onOkClicked(): void {
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_CLOSED, this._currentMessageType);
	}

	protected onHomeClicked(): void {
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_CLOSED, this._currentMessageType);
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_HOME_CLICKED);

	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupModule.ts